import styled from "styled-components/macro";

import FnrDividerLine from "UI/FnrDividerLine/FnrDividerLine";

import ArchiveSignup from "./Options/ArchiveSignup";
import CloseAt from "./Options/CloseAt";
import Confetti from "./Options/Confetti";
import CreatedBy from "./Options/CreatedBy";
import DeleteSignup from "./Options/DeleteSignup";
import DuplicateSignup from "./Options/DuplicateSignup";
import EditConfirmationEmail from "./Options/EditConfirmationEmail";
import MultipleItems from "./Options/MultipleItems";
import NotifyAdmin from "./Options/NotifyAdmin";
import PublicSignup from "./Options/PublicSignup";
import ShareWithOtherGroups from "./Options/ShareWithOtherGroups";
import SignupReminders from "./Options/SignupReminders";


export default function Options() {
  return (
    <Wrapper data-cy="signupOptionsWrapper">
      <MultipleItems />
      <SignupReminders />
      <CloseAt />
      <Confetti />
      {/* <NotifyAdmin /> */}
      <EditConfirmationEmail />

      <MoreOptions>
        <FnrDividerLine title="Privacy" />

        <PublicSignup />
        <ShareWithOtherGroups />
      </MoreOptions>

      <MoreOptions>
        <FnrDividerLine title="More Options" />
        <MoreOptionsButtons>
          <DuplicateSignup />
          <ArchiveSignup />
          <DeleteSignup />
        </MoreOptionsButtons>
        <CreatedBy />
      </MoreOptions>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding: 18px;
  box-sizing: border-box;
  max-height: 100%;
  overflow: auto;
  padding-bottom: 140px;
`;

const MoreOptions = styled.div`
  margin-top: 48px;
`;

const MoreOptionsButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: -12px;
  margin-left: -12px;
  padding-block: 0;

  @media (max-width: 451px) {
    flex-direction: column;
  }
`;